export var ValidatorMode;
(function (ValidatorMode) {
    ValidatorMode["sudo"] = "0x00000000";
    ValidatorMode["plugin"] = "0x00000001";
    ValidatorMode["enable"] = "0x00000002";
})(ValidatorMode || (ValidatorMode = {}));
//# sourceMappingURL=kernel.js.map